import(/* webpackMode: "eager" */ "/codebuild/output/src3604662019/src/wello-client/packages/wello/src/app/error.tsx");
